import React, { useState, createContext, useContext } from 'react';
interface Client {
  id: string;
  name: string;
  domain: string;
}
interface ClientContextType {
  currentClient: Client | null;
  setCurrentClient: (client: Client | null) => void;
  isImpersonating: boolean;
  setIsImpersonating: (state: boolean) => void;
}
const ClientContext = createContext<ClientContextType | undefined>(undefined);
export const ClientProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [currentClient, setCurrentClient] = useState<Client | null>(null);
  const [isImpersonating, setIsImpersonating] = useState(false);
  return <ClientContext.Provider value={{
    currentClient,
    setCurrentClient,
    isImpersonating,
    setIsImpersonating
  }} data-id="element-1605">
      {children}
    </ClientContext.Provider>;
};
export const useClient = () => {
  const context = useContext(ClientContext);
  if (context === undefined) {
    throw new Error('useClient must be used within a ClientProvider');
  }
  return context;
};